import { css } from '@emotion/react';
import { Outlet, createRootRouteWithContext } from '@tanstack/react-router';
import { Authn } from '@frontend/auth';
import { ShellTitleBar } from '@frontend/shell-theme';
import { TracerModal } from '@frontend/tracer-modal';
import { theme } from '@frontend/theme';
import { Layout } from '../components';
import { ErrorBoundary } from '../components/ErrorBoundary';

const hasShellThemeEnabled =
  window.shell &&
  window.shell?.isShell &&
  window.shell?.featureAvailability?.has('shell-theme') &&
  !window.shell?.featureAvailability?.has('shell-title-bar-view');

const styles = {
  container: css`
    display: flex;
    flex: 1;
    justify-content: center;
  `,
  main: css`
    display: flex;
    flex: 1;
    flex-direction: column;
    justify-content: center;
    background-color: ${theme.colors.white};
  `,
  innerDiv: css`
    display: flex;
    flex-direction: column;
    height: 100%;
  `,
};

const Root = () => {
  return (
    <>
      <>
        {hasShellThemeEnabled && (
          <ErrorBoundary tier='feature' feature='gatekeeper.shell-title-bar' fallback={() => <></>}>
            <ShellTitleBar />
          </ErrorBoundary>
        )}
        <div css={styles.container}>
          <main css={styles.main} data-testid='gatekeeper-root-outlet'>
            <div css={styles.innerDiv}>
              <Layout background={'blue'}>
                {/* tanstack router defaultErrorComponent catches route level errors that occur within the Outlet */}
                <Outlet />
              </Layout>
            </div>
          </main>
        </div>
      </>
      <ErrorBoundary tier='feature' feature='gatekeeper.tracer-modal'>
        <TracerModal />
      </ErrorBoundary>
    </>
  );
};

export const Route = createRootRouteWithContext<{ auth: Authn }>()({
  component: Root,
  notFoundComponent: () => <div>Not Found</div>,
});
